import React, { Component } from "react";
import HeaderNew from "./HeaderNew";
import FooterNew from "./FooterNew";
import Footer from "../Copyrights/Footer";
import BackArrow from "./../../../public/assets/images/back-arrow-dark.svg";
import Chart from "./../../../public/assets/images/chart-image.png";
import MiniArrow from "./../../../public/assets/images/mini-arrow.svg"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from 'jquery';
import { getPlan } from '../../API/FetchCall';

import icon1 from "./../../../public/assets/newpage/icon1.png";
import icon2 from "./../../../public/assets/newpage/icon2.png";
import icon3 from "./../../../public/assets/newpage/icon3.png";
import icon4 from "./../../../public/assets/newpage/icon4.png";

import sampleview1 from "../../assets/images/view1.png";
import sampleview2 from "../../assets/images/view2.png";
import sampleview3 from "../../assets/images/view3.png";

import step1 from "../../assets/images/icons/signup.png";
import step2 from "../../assets/images/icons/cash-on-delivery.png";
import step3 from "../../assets/images/icons/approve.png";
import step4 from "../../assets/images/icons/launch.png";

import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import ModalHeader from 'reactstrap/lib/ModalHeader';

import { Helmet } from 'react-helmet';

var CurrencyFormat = require('react-currency-format');

const benefits = [<ul><li>200-word write-up about yourself and services offered on your page.</li>
  <li>Manage your profile page frequently to improve brand and visibility.</li>
  <li>Upload up to 8 images on your profile page.</li>
  <li>Post your social media link(s) on your page.</li>
  <li>Email interaction with prospective parents.</li>
  <li>Respond to users on their feedback.</li>
  <li>Upload videos links to showcase excellence.</li>
  <li>Publish two articles a year on thought leadership.</li>
</ul>, <ul>
  <li>300-word write-up about yourself and services offered on your page.</li>
  <li>Manage your profile page frequently to improve brand and visibility.</li>
  <li>Upload up to 15 images on your profile page.</li>
  <li>Post your social media link(s) on your page.</li>
  <li>Drive showcase you in some of our social media.</li>
  <li>Email interaction with prospective parents.</li>
  <li>Upload videos links to showcase excellence.</li>
  <li>Publish two articles a year on thought leadership.</li>
</ul>];

import individualBG from "../../assets/images/bannerbgindividual.png";

class NewLandingPageInd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan_list2: [],
      current_plan: []
    };
    this.getPlanList();
    this.slideCustom = React.createRef();
    this.slideCustom2 = React.createRef();

  }


  componentDidMount() {
    let logged = localStorage.getItem("authentication");
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    console.log('auth_data.role', logged);
    if (logged == 'true' && auth_data != 'null' && auth_data.role == 1) {
      window.location.href = '/dashboard/dashboard';
    } else if (logged == 'true' && auth_data != 'null' && auth_data.role == 3) {
      window.location.href = '/partner/profile';
    }

  }

  analyticsOffer = () => {

    this.setState({
      offerModal: false,
      analyticsModal: true,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToOffer = () => {
    this.setState({
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };
  backToSlide = () => {
    this.setState({
      offerModal: false,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").removeClass("in");
    }, 500);
  };

  getPlanList = async () => {
    let planData = JSON.stringify({
      user_type: 2,
    });

    getPlan(planData).then((response) => {
      if (response.status == 1) {
        this.setState({
          plan_list2: response.results,
        });

      } else {
        console.log('else')
      }
    });
  }


  handlePlan = (id) => {
    let plan_info = this.state.plan_list2.filter(o => o.id == id);
    console.log('plan_info', plan_info)
    //window.$("#bewisestandard").modal("show");

    this.setState({
      current_plan: plan_info,
      plan_id: id,
      offerModal: true,
      analyticsModal: false,
    });
    setTimeout(function () {
      $(".modal").addClass("in");
    }, 500);
  };

  render() {


    var settings = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 4,
      autoplay: false,
      arrows: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    };


    var packages_settings = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 2,
      slidesToScroll: 1,
      initialSlide: 1,
      autoplay: false,
      autoplaySpeed: 5000
    };

    var packages_settings_mobile = {
      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      autoplay: false,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            initialSlide: 0,
            slidesToScroll: 1
          }
        }
      ]
    };

    var settings_dashboards = {

      dots: false,
      infinite: false,
      speed: 2000,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

    };

    /* <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" /> */

    return (
      <React.Fragment>

        <Helmet>
        <title>BeWise individual Partners - Enhancing Education Together</title>
        <meta name="description" content={'BeWise partners with educators to enhance education. Learn more about our collaborative efforts and programs by visiting our website.'} />
        </Helmet>

        <HeaderNew />

        <div class="row display-flex-center mainrowheader" style={{ marginTop: "85px" }}>
          <div class="col-lg-2 col-sm-1 col-md-1">

          </div>
          <div class="col-lg-8 col-sm-10 col-md-10">

            <div class="bannersection_ind">

              <div class="bheader">Welcome to <span className="bluetext">BeWise</span> Partner Program</div>

              <div class="bbg"><img src={individualBG} className="bannerbg" /></div>

              <div class="biconbox">

                <Slider {...settings}>

                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon1} /></div>
                      <div class="info">
                        <h3 class="titlesm">Efficiency</h3>
                        <h4 class="subtitle">Reaching target audience continuosly with</h4>
                        <ul class="boxli">
                          <li>Brand recall</li>
                          <li>Returns</li>
                          <li>Reach</li>
                          <li>Talent access</li>
                          <li>Focus on objective</li>
                        </ul>
                      </div>
                    </div>
                    <div class="space"></div>
                  </div>


                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon2} /></div>
                      <div class="info">
                        <h3 class="titlesm">Engagement</h3>
                        <h4 class="subtitle">Continously with target Audience on</h4>
                        <ul class="boxli">
                          <li>Brand values</li>
                          <li>Leadership and followers</li>
                          <li>Attracking talent</li>
                          <li>Leveraging feedback</li>
                          <li>Reaching events beyond</li>

                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>


                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon3} /></div>
                      <div class="info">
                        <h3 class="titlesm">Excellence</h3>
                        <h4 class="subtitle">New Industry Standards</h4>
                        <ul class="boxli">
                          <li>Data based decisions</li>
                          <li>Transparency and leadership</li>
                          <li>Enrollments 24x7</li>
                          <li>Build insights and leadership for commnunity</li>
                          <li>Frequently showcase successes to attract the best</li>
                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>

                  <div class="box">
                    <div class="icon">
                      <div class="image"><img src={icon4} /></div>
                      <div class="info">
                        <h3 class="titlesm">Enable(ment)</h3>
                        <h4 class="subtitle">Raise Industry Standards</h4>
                        <ul class="boxli">

                          <li>Brand strength 24x7</li>
                          <li>Continuous benchmarking & tracking competitiveness</li>
                          <li>Connected with trends and quick to customize</li>
                          <li>Lead thought leadership for industry</li>
                          <li>Attracting talent continuously</li>

                        </ul>

                      </div>
                    </div>
                    <div class="space"></div>
                  </div>

                </Slider>

              </div>
            </div>

            <div class="packagesection">

              <div class="planheader">BeWise Partner Subscription Packages</div>

              <div class="planbox formobile">

                <Slider {...packages_settings_mobile} ref={this.slidepackages}>


                  {this.state.plan_list2.map((item, j) => {

                    return (

                      <div class="planBox" style={{ minHeight: '500px' }}>
                        <div class="row display-flex-center">
                          <div class="col-lg-6 col-xs-6 col-sm-6 col-md-6 text-right" style={{ borderRight: '8px solid' + `${item.icon_color}` }} >
                            <div className="companyname">BeWise</div>
                            <div className="planname" style={{ color: `${item.icon_color}` }}>{item.plan_name}</div>
                          </div>
                          <div class="col-lg-6 col-xs-6 col-sm-6 col-md-6 text-left"><a href="/individual_signup" className="btnlike">SignUp</a></div>
                        </div>
                        <div class="row display-flex-center plandesc">
                          <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo" style={{ paddingTop: "30px", paddingBottom: "30px" }}>

                            <h6 style={{ color: `${item.icon_color}` }}>Package Details</h6>
                            <div class="planbenefits landing-benfits" dangerouslySetInnerHTML={{ __html: item.plan_offer }}></div>
                            <div className='view-package'>
                              <a onClick={() => this.handlePlan(item.id)}>View More</a>
                            </div>
                          </div>
                        </div>
                      </div>


                    )
                  })}

                </Slider>

              </div>

              <div class="planbox fordesktop">

                <Slider {...packages_settings} ref={this.slidepackages}>


                  {this.state.plan_list2.map((item, j) => {

                    return (

                      <div class="planBox" style={{ minHeight: '500px' }}>
                        <div class="row display-flex-center">
                          <div class="col-lg-3 col-xs-3 col-sm-3 col-md-3">
                            <div className="stamp-img">
                              <img src={item.baseurl + item.stamp_img} />
                            </div>
                          </div>
                          <div class="col-lg-5 col-xs-5 col-sm-5 col-md-5 landing-plan-name">
                            <div className="companyname">BeWise</div>
                            <div className="planname" style={{ color: `${item.icon_color}` }}>{item.plan_name}</div>
                          </div>
                          <div class="col-lg-4 col-xs-4 col-sm-4 col-md-4">
                            <a href="/individual_signup" className="btnlike">SignUp</a>
                          </div>
                        </div>
                        <div class="row display-flex-center plandesc">
                          <div class="col-lg-12 col-xs-12 col-sm-12 col-md-12 text-left planinfo" style={{ paddingTop: "30px", paddingBottom: "30px" }}>

                            <h6 style={{ color: `${item.icon_color}` }}>Package Details</h6>
                            <div class="planbenefits landing-benfits" dangerouslySetInnerHTML={{ __html: item.plan_offer }}></div>
                            <div className='view-package'>
                              <a onClick={() => this.handlePlan(item.id)}>View More</a>
                            </div>
                          </div>
                        </div>
                      </div>


                    )
                  })}

                </Slider>

              </div>
            </div>

            <div class="howtobesection">

              <div class="planheader">How to be BeWise Partner?</div>
              <div class="stepbox">

                <ol>
                  <li className="step1clr">
                    <p class="event-date"><img src={step1} /></p>
                    <p class="event-step">Step 1</p>
                    <p class="event-description">Click on Sign Up and provide us with required details to partner with BeWise.</p>
                  </li>
                  <li className="step2clr">
                    <p class="event-date"><img src={step2} /></p>
                    <p class="event-step">Step 2</p>
                    <p class="event-description">Select a Package suitable to your work. Speak to our assigned Sales Team for any support required.</p>
                  </li>
                  <li className="step3clr">
                    <p class="event-date"><img src={step3} /></p>
                    <p class="event-step">Step 3</p>
                    <p class="event-description">BeWise team will Verify and Validate the details provided.</p>
                  </li>
                  <li className="step4clr">
                    <p class="event-date"><img src={step4} /></p>
                    <p class="event-step">Step 4</p>
                    <p class="event-description">Access you Account page to input any additional information. Also, Add Branches if you have</p>
                  </li>
                </ol>

              </div>

            </div>

            <div class="dashboardsection">

              <div class="dashboardheader">Dashboards and Partner Account Page - Sample Views </div>

              <div class="dashboardbox" id="dashboards">

                <Slider {...settings_dashboards} ref={this.slideCustom2}>

                  <div className="dashboardsampleview">
                    <img src={sampleview1} />
                  </div>

                  <div className="dashboardsampleview">
                    <img src={sampleview2} />
                  </div>

                  <div className="dashboardsampleview">
                    <img src={sampleview3} />
                  </div>


                </Slider>
              </div>

            </div>
          </div>
          <div class="col-lg-2 col-sm-1 col-md-1">

          </div>
        </div>

        <Modal isOpen={this.state.analyticsModal} size="lg">
          <ModalHeader>
            <div className="col-md-6 mini-arrow" style={{ cursor: 'pointer' }} onClick={this.backToOffer}>
              <img src={BackArrow} alt="MiniArrow" />&nbsp;&nbsp; Back
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={this.backToSlide}>
              <i class="fa fa-times-circle-o" aria-hidden="true"></i>
            </button>
          </ModalHeader>
          <ModalBody className='sign-upmodal'>
            {this.state.current_plan.length > 0 && (
              <div className="row">

                <div className="col-sm-8">
                  <h1>Analytics that we offer</h1>
                  <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].analytics_offer }}></div>
                  {(this.state.current_plan[0].analytics_soon) && (
                    <div>
                      <h1>Coming Soon</h1>
                      <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].analytics_soon }}></div>
                    </div>
                  )}
                </div>
                <div className="col-sm-4">
                  <div className="cardhead">
                    <div className="img-box">
                      <img src={this.state.current_plan[0].baseurl + this.state.current_plan[0].icon} alt="plan icon" />
                    </div>
                    <div className="img-rightcontent">
                      <h2 style={{ borderBottom: `4px solid ${this.state.current_plan[0].icon_color}` }}>
                        {this.state.current_plan[0].site}
                        <br />
                        {this.state.current_plan[0].plan_name}
                      </h2>
                       
                      <div><a href="mailto:contact@bewise.in">Email us</a> to receive our launch offers.</div>
                      <div><small>Please include your phonenumber for us to call back</small></div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.offerModal} size="lg">
          <ModalHeader>
            <div className="col-md-6 mini-arrow" style={{ cursor: 'pointer' }} onClick={this.backToSlide}>
              <img src={BackArrow} alt="MiniArrow" />&nbsp;&nbsp; Back
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={this.backToSlide}>
              <i class="fa fa-times-circle-o" aria-hidden="true"></i>
            </button>
          </ModalHeader>
          <ModalBody className='sign-upmodal'>
            {this.state.current_plan.length > 0 && (
              <div className="row sign-upmodal">
                <div className="col-sm-8">
                  <h1>Our Offering</h1>
                  <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].plan_offer }}></div>
                  {(this.state.current_plan[0].plan_soon) && (
                    <div>
                      <h1>Coming Soon</h1>
                      <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].plan_soon }}></div>
                    </div>
                  )}
                  <div className="mini-arrow" style={{ cursor: 'pointer' }} onClick={() => this.analyticsOffer()}>
                    Analytics offer <img src={MiniArrow} alt="MiniArrow" />
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="cardhead">
                    <div className="img-box">
                      <img src={this.state.current_plan[0].baseurl + this.state.current_plan[0].icon} alt="plan icon" />
                    </div>
                    <div className="img-rightcontent">
                      <h2 style={{ borderBottom: `4px solid ${this.state.current_plan[0].icon_color}` }}>
                        {this.state.current_plan[0].site}
                        <br />
                        {this.state.current_plan[0].plan_name}
                      </h2>
                      <h1>
                        <span>
                          <CurrencyFormat value={this.state.current_plan[0].base_price != '' ? this.state.current_plan[0].base_price : 0}
                            displayType={'text'} thousandSeparator={true} prefix={'₹'} />
                        </span>
                        <span>/Year</span>
                        <br />
                        <small>{this.state.current_plan[0].offer_name}</small>
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </ModalBody>
        </Modal>
        <Footer />

        <div className="modal fade" id="bewisestandard" role="dialog">
          <div className="modal-dialog  modal-lg">
            <div className="modal-content">
              <div class="modal-header">
                <div className="col-md-6 mini-arrow">
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={() => this.backToSlide()}>
                  <i class="fa fa-times-circle-o" aria-hidden="true"></i>
                </button>
              </div>
              {this.state.current_plan.length > 0 && (
                <div className="modal-body sign-upmodal">
                  <div className="row">
                    <div className="col-sm-8">
                      <h1>Our Offering</h1>
                      <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].plan_offer }}></div>
                      {(this.state.current_plan[0].plan_soon) && (
                        <div>
                          <h1>Coming Soon</h1>
                          <div dangerouslySetInnerHTML={{ __html: this.state.current_plan[0].plan_soon }}></div>
                        </div>
                      )}
                      <div className="mini-arrow" style={{ cursor: 'pointer' }} onClick={() => this.analyticsOffer()}>
                        Analytics offer <img src={MiniArrow} alt="MiniArrow" />
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="cardhead">
                        <div className="img-box">
                          <img src={this.state.current_plan[0].baseurl + this.state.current_plan[0].icon} alt="plan icon" />
                        </div>
                        <div className="img-rightcontent">
                          <h2 style={{ borderBottom: `4px solid ${this.state.current_plan[0].icon_color}` }}>
                            {this.state.current_plan[0].site}
                            <br />
                            {this.state.current_plan[0].plan_name}
                          </h2>
                          {/* {this.state.current_plan[0].discount_percent > 0 && (
                            <h2>
                              <span>
                                <CurrencyFormat value={this.state.current_plan[0].base_price != '' ? this.state.current_plan[0].base_price : 0}
                                  displayType={'text'} thousandSeparator={true} prefix={'₹'} />
                              </span>
                              <span>/Year</span>
                            </h2>
                          )} */}
                          <div><a href="mailto:contact@bewise.in">Email us</a> to receive our launch offers.</div>
                      <div><small>Please include your phonenumber for us to call back</small></div>
                           
                          {/* <button className="btn blue-btn mt-20" onClick={() => this.handleSignup(this.state.current_plan[0].plan_id)}>SIGN UP </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </React.Fragment >
    );
  }
}

export default NewLandingPageInd;



// WEBPACK FOOTER //
// ./src/components/LandingPages/ind_landingpage.jsx